<script setup lang="ts">
import { ButtonComponent } from '@metapic-apps/shared'
import { computed, ref, watch } from 'vue'

import { useNotificationSubscriptionInfo } from '@/api/notification-subscriptions.api'
import SettingsIcon from '@/assets/icons/settings.svg?component'
import { RequestStatus } from '@/lib/types/common.types'
import { useNotificationStore } from '@/stores/notifications.stores'
import { useUserStore } from '@/stores/user.stores'
import { LoadingComponent, TypographyComponent } from '@/ui-library'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'

const props = defineProps<{ campaignId: string }>()
const userStore = useUserStore()
const notificationStore = useNotificationStore()
const subscriberId = computed(() => userStore.subscriberId)
const isOpen = ref(false)
const { data, status, updateSubscription } = useNotificationSubscriptionInfo(subscriberId, props.campaignId)
const isEnabled = ref(false)

watch(
  () => data.value,
  () => {
    if (data.value) {
      isEnabled.value = data.value.enabled
    }
  },
)

const handleChange = async (value: boolean) => {
  await updateSubscription(userStore.subscriberId, {
    topic: `campaign:${props.campaignId}`,
    enabled: value,
    subscriber: {
      id: userStore.subscriberId,
      email: userStore.user.email,
    },
  })
}
</script>
<template>
  <el-dropdown v-if="!notificationStore.notificationsUnavailable" trigger="click" :persistent="false">
    <ButtonComponent is-icon variant="text" @click="isOpen = true">
      <SettingsIcon />
    </ButtonComponent>
    <template #dropdown>
      <BoxComponent :pt="16" :pb="16" :w="320">
        <template v-if="status === RequestStatus.Success">
          <BoxComponent :pr="16" :pl="16">
            <TypographyComponent variant="headline-small">Notification settings</TypographyComponent>
          </BoxComponent>
          <BoxComponent :p="16" class="campaign-participants-settings__action">
            <FlexComponent justify="space-between" align="center">
              <TypographyComponent variant="title-large">Notify me about updates</TypographyComponent>
              <el-switch v-model="isEnabled" size="large" @change="handleChange" />
            </FlexComponent>
          </BoxComponent>
        </template>
        <template v-else>
          <BoxComponent :p="16">
            <LoadingComponent :size="48" />
          </BoxComponent>
        </template>
      </BoxComponent>
    </template>
  </el-dropdown>
</template>
<style lang="scss" scoped>
.campaign-participants-settings__action {
  &:hover {
    background: rgba(3, 30, 81, 0.04);
  }
}
</style>
